const invalidCharacterRanges = [
  '\u00a9',
  '\u00ae',
  '[\u2000-\u3300]',
  '\ud83c[\ud000-\udfff]',
  '\ud83d[\ud000-\udfff]',
  '\ud83e[\ud000-\udfff]'
];

export const createInvalidCharactersRegExp = () => new RegExp(invalidCharacterRanges.join('|'), 'g');

export const hasInvalidCharacters = value => (value ? createInvalidCharactersRegExp().test(value) : false);
